export enum PlacementPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  TOP_RIGHT = 'topRight',
  TOP_LEFT = 'topLeft',
  BOTTOM_RIGHT = 'bottomRight',
  BOTTOM_LEFT = 'bottomLeft',
}
